import { render, staticRenderFns } from "./EnglishResumeEdit.vue?vue&type=template&id=0b01b100"
import script from "./EnglishResumeEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumeEdit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports